<template>
  <li
    v-if="sidebarAccessManager(item.route)"
    :key="item.route"
    class="nav-item"
    :class="{
      'active': isActive,
      'disabled': item.disabled
    }"
  >
    <b-link
      :key="item.route"
      v-bind="linkProps"
      class="d-flex align-items-center"
    >
      <!-- <feather-icon :icon="item.icon || 'CircleIcon'" /> -->
      <GjIcon
        v-if="item.icon"
        :key="item.route"
        :name="item.icon"
        class="mr-1"
      />
      <span class="menu-title text-truncate">{{ $tk(item.title) }}</span>
      <b-badge
        v-if="item.tag"
        :key="item.route+'badge'"
        pill
        :variant="item.tagVariant || 'primary'"
        class="ml-50"
      >
        {{ item.tag }}
      </b-badge>
    </b-link>
  </li>
</template>

<script>
// import { useUtils as useAclUtils } from '@core/libs/acl'
import { BLink, BBadge } from 'bootstrap-vue'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import { sidebarAccessManager } from '@/utils/accessManager/accessManager'
import useVerticalNavMenuLink from './useVerticalNavMenuLink'
import mixinVerticalNavMenuLink from './mixinVerticalNavMenuLink'

export default {
  components: {
    BLink,
    BBadge,
    GjIcon,
  },
  mixins: [mixinVerticalNavMenuLink],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const { isActive, linkProps, updateIsActive } = useVerticalNavMenuLink(props.item)
    const { t } = useI18nUtils()
    // const { canViewVerticalNavMenuLink } = useAclUtils()

    return {
      isActive,
      linkProps,
      updateIsActive,

      // ACL
      // canViewVerticalNavMenuLink,
      sidebarAccessManager,

      // i18n
      t,
    }
  },

}
</script>
